import React from 'react'
import { Calendar } from 'lucide-react'
import { Card, CardContent } from '../../ui'
import TemporadaSelector from '../pagos/TemporadaSelector'
import { useDeportes } from '../../../hooks/useDeportes'
import { parseLocalDate } from '../../../lib/dateUtils'

// La temporada NO es un filtro: es el sujeto de la pantalla. Todo lo que se hace
// aqui (inscribir, activar, dar de baja) ocurre DENTRO de ella. Puesta en la fila
// de filtros se leia como un control mas; aqui manda. Importa de verdad cuando el
// club tiene dos temporadas abiertas a la vez (p. ej. flag y tackle): equivocarse
// significa inscribir al jugador en el ciclo que no era.

const ESTADO = {
  abierta: { label: 'Abierta', cls: 'bg-green-100 text-green-700' },
  cerrada: { label: 'Cerrada', cls: 'bg-muted text-muted-foreground' },
  planeada: { label: 'Planeada', cls: 'bg-amber-100 text-amber-700' },
}

const fmt = (d) => {
  const f = parseLocalDate(d)
  return f ? f.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : null
}

const TemporadaContextBar = ({ temporada, temporadas, value, onChange }) => {
  const { label: deporteLabel } = useDeportes()
  const estado = ESTADO[temporada?.estado]
  const desde = fmt(temporada?.fecha_inicio)
  const hasta = fmt(temporada?.fecha_fin)

  return (
    <Card className="border-border/80 bg-muted/30">
      <CardContent className="flex flex-wrap items-center gap-4 p-4">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Calendar className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Temporada
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="truncate text-lg font-semibold text-foreground">
              {temporada?.nombre || 'Sin temporada'}
            </h2>
            {estado && (
              <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium leading-none ${estado.cls}`}>
                {estado.label}
              </span>
            )}
          </div>
          {temporada && (
            <p className="text-sm text-muted-foreground">
              {deporteLabel(temporada.deporte_id)}
              {desde && hasta && ` · ${desde} – ${hasta}`}
            </p>
          )}
        </div>
        <div className="ml-auto flex items-center gap-2">
          <span className="hidden text-sm text-muted-foreground sm:inline">Cambiar:</span>
          <TemporadaSelector
            temporadas={temporadas}
            value={value}
            onChange={onChange}
            className="h-10"
          />
        </div>
      </CardContent>
    </Card>
  )
}

export default TemporadaContextBar
